var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseSettings } from '../../Settings/BaseGeneralSettingsWrapper';
import { RulesSet } from '@shared/utils/Rules/RulesSet';
import { Resources } from '@shared/localizations/Resources';
import { OrderType } from '@shared/utils/Trading/OrderType';
export function getConfirmationMarginInfoAsync(parameters) {
    return __awaiter(this, void 0, void 0, function* () {
        const result = {
            totalFee: NaN,
            estAvailableCash: NaN,
            offMarketError: null,
            marginResponse: null,
        };
        if (parameters.length === 0) {
            return result;
        }
        const requestParameters = parameters.filter(shouldRequest);
        const requestParametersLength = requestParameters.length;
        if (requestParametersLength === 0) {
            return result;
        }
        const account = requestParameters[0].marginInfoParameters.account;
        const dataCache = account.DataCache;
        const marginResponse = result.marginResponse = yield dataCache.SendMarginRequest(requestParameters.map((param) => param.marginInfoParameters));
        // Some parameters were not processed
        if (!isValidArray(marginResponse === null || marginResponse === void 0 ? void 0 : marginResponse.Groups) || marginResponse.Groups.length !== requestParametersLength) {
            if (isAllowTotalFee(account)) {
                result.totalFee = undefined;
            }
            if (isAllowEstAvailableCash(account)) {
                result.estAvailableCash = undefined;
            }
            return result;
        }
        const offMarketErrors = [];
        for (let i = 0; i < requestParametersLength; i++) {
            const request = requestParameters[i];
            const marginResponseGroup = marginResponse.Groups[i];
            if (isAllowOffMarketWarnings() && isValidString(marginResponseGroup.OffMarketEnabled)) {
                const orderType = request.marginInfoParameters.orderType;
                const offMarketError = orderType === OrderType.Market
                    ? Resources.getResource('general.warnings.offMarket.PlaceMarketOrder')
                    : Resources.getResource('general.warnings.offMarket.PlacePendingOrder');
                offMarketErrors.push(offMarketError);
            }
            if (request.isOnlyOffMarket) {
                continue;
            }
            if (isAllowTotalFee(account)) {
                if (isValidNumber(marginResponseGroup.TotalFee)) {
                    result.totalFee = marginResponseGroup.TotalFee;
                }
            }
            if (isAllowEstAvailableCash(account)) {
                if (isValidNumber(marginResponseGroup.EstAvailableCash)) {
                    result.estAvailableCash = marginResponseGroup.EstAvailableCash;
                }
            }
        }
        if (offMarketErrors.length > 0) {
            result.offMarketError =
                offMarketErrors.length > 1
                    ? Resources.getResource('general.warnings.offMarket.PlacePendingOrderMultiply')
                    : offMarketErrors[0];
        }
        return result;
    });
}
//#region Helper
function isAllowOffMarketWarnings() {
    return BaseSettings.isShowOffMarketWarnings;
}
function isAllowTotalFee(account) {
    return account.DataCache.isAllowedForMyUser(RulesSet.FUNCTION_DISPLAY_FEES_ON_CONFIRMATIONS);
}
function isAllowEstAvailableCash(account) {
    return account.DataCache.isAllowedForMyUser(RulesSet.LEVERAGE_USAGE_WARN);
}
function shouldRequest(parameter) {
    const account = parameter.marginInfoParameters.account;
    const isAllowOffMarket = isAllowOffMarketWarnings();
    if (parameter.isOnlyOffMarket) {
        return isAllowOffMarket;
    }
    return isAllowOffMarket || isAllowTotalFee(account) || isAllowEstAvailableCash(account);
}
//#endregion Helper
